<template>
  <div id="reckon-way">
    <CultureNav />

    <div class="content-container adventure-shell">
      <div class="content">
        <v-container>
          <section
            v-for="section in journeySections"
            :key="section.id"
            class="journey-section"
          >
            <div class="section-heading">
              <div>
                <p class="section-eyebrow">{{ section.eyebrow }}</p>
                <h2 class="section-title">{{ section.title }}</h2>
                <p class="section-copy">{{ section.description }}</p>
              </div>
            </div>
            <div class="journey-cards">
              <CultureCard
                v-for="journey in section.items"
                :key="journey.id"
                :title="journey.title"
                :eyebrow="journey.eyebrow"
                :summary="journey.summary"
                :image="journey.image"
                :metadata="journey.metadata"
                :href="journey.href"
                :status="journey.status"
              />
            </div>
          </section>
        </v-container>
      </div>
    </div>

    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue';
import CultureNav from '../components/reckon-way/culture/CultureNav.vue';
import CultureCard from '../components/reckon-way/culture/CultureCard.vue';
import { journeySections } from '../content/culture/journeys';
import { visibleContent } from '../lib/draftMode';

export default {
  name: 'PastAdventuresView',
  components: {
    AppFooter,
    CultureNav,
    CultureCard,
  },
  computed: {
    journeySections() {
      return journeySections.map((section) => ({
        ...section,
        items: visibleContent(
          section.items,
          this.$store.getters.draftModeEnabled,
          this.$store.getters.isAuthorizedReckonUser,
        ),
      })).filter((section) => section.items.length);
    },
  },
};
</script>

<style scoped>
.adventure-shell {
  background: #050505;
  padding-bottom: 60px;
  padding-top: 36px;
}

.journey-section {
  border-top: 1px solid #252525;
  margin: 24px 0 52px;
  padding-top: 42px;
}

.journey-cards {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.section-eyebrow {
  color: #e23232;
  font-family: "Oswald", serif;
  font-size: .8rem;
  font-weight: 900;
  margin: 0 0 6px;
  text-transform: uppercase;
}

.section-heading {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}

.section-heading > div {
  min-width: 0;
}

.section-title {
  color: #fff;
  font-family: "Oswald", serif;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1.1;
  margin: 0 0 8px;
  padding: 0;
}

.section-copy {
  color: #b8b8b8;
  font-size: 1.05rem;
  line-height: 1.45;
  margin: 0;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 1.7rem;
  }
}
</style>
